// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_XHy","cls2":"ResearchInterestTags-cls2_5Q3 ResearchInterestTags-cls1_XHy"};